import { Link } from 'react-router-dom';
import SEOHead from '@/components/feature/SEOHead';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

const faqs = [
  {
    question: '掌中美母主要提供哪些服务？',
    answer: '掌中美母专注于为现代母亲提供全方位的美丽养护方案，包括科学肌肤护理指导、个人形象提升建议、实用美丽秘籍分享以及真实妈妈故事激励。我们通过专业的文章内容和社群互动，帮助每一位妈妈在繁忙生活中保持自信与美丽。',
  },
  {
    question: '掌中美母的内容是否适合所有年龄段的妈妈？',
    answer: '是的！我们的内容覆盖了从年轻新妈妈到成熟妈妈的各个阶段。无论是产后肌肤修复、职场形象管理，还是熟龄肌护理，我们都根据不同年龄段妈妈的需求，提供针对性的美丽养护方案和建议。',
  },
  {
    question: '如何获取掌中美母的最新内容？',
    answer: '您可以通过关注我们的微信公众号"掌中美母"获取每日推送的美丽养护小贴士。同时，我们的网站会持续更新护肤方案、穿搭指南和妈妈故事等内容，欢迎经常回来看看。',
  },
  {
    question: '掌中美母推荐的护肤产品在哪里可以购买？',
    answer: '掌中美母目前主要提供专业的护肤知识和产品评测，帮助妈妈们了解不同产品的特点和适用肤质。具体的产品购买建议会在文章中提供参考信息，您可以根据自身需求选择合适的购买渠道。',
  },
  {
    question: '我可以投稿分享自己的美丽故事吗？',
    answer: '当然可以！我们非常欢迎妈妈们分享自己的美丽蜕变经历和养护心得。您可以通过"关于我们"页面中的联系方式与我们取得联系，编辑团队会认真阅读每一份投稿并与您沟通发布事宜。',
  },
];

const features = [
  {
    icon: 'ri-leaf-line',
    title: '科学护肤',
    description: '基于皮肤科学理论，为妈妈量身定制安全有效的护肤方案',
  },
  {
    icon: 'ri-user-star-line',
    title: '形象定制',
    description: '从穿搭到妆容，帮助妈妈打造属于自己的独特风格',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: '身心养护',
    description: '关注妈妈的身心健康，由内而外地焕发美丽光彩',
  },
  {
    icon: 'ri-group-line',
    title: '温暖社群',
    description: '汇聚千万妈妈的美丽社群，分享经验、互相鼓励',
  },
];

function HomeHero() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20warm%20abstract%20background%20with%20soft%20rose%20and%20cream%20gradients%2C%20delicate%20floral%20patterns%2C%20gentle%20feminine%20textures%2C%20minimalist%20artistic%20style%2C%20soft%20diffused%20lighting%2C%20dreamy%20atmosphere%2C%20warm%20neutral%20tones%20with%20subtle%20blush%20accents%2C%20abstract%20beauty%20concept&width=1800&height=1200&seq=hero-main-2026&orientation=landscape"
        alt="掌中美母 - 专属美丽养护体验"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 md:mb-6 leading-tight">
          掌中美母
        </h1>
        <p className="text-base md:text-xl text-white/90 mb-4 max-w-2xl mx-auto leading-relaxed">
          为现代母亲打造专属美丽养护方案，帮助每一位妈妈在繁忙生活中找回自信光彩
        </p>
        <p className="text-sm md:text-base text-white/70 mb-8 max-w-xl mx-auto">
          从肌肤护理到整体形象提升，轻松掌握属于自己的美丽主权
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/skin-care"
            className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-6 py-3 rounded-md font-medium text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            探索美丽方案
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 bg-background-50/20 text-white border border-white/30 px-6 py-3 rounded-md font-medium text-sm hover:bg-background-50/30 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}

function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950 mb-3">
            探索美丽养护
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            选择你感兴趣的方向，开启专属美丽之旅
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative bg-background-100 rounded-lg overflow-hidden h-48 md:h-56 cursor-pointer"
            >
              <img
                src={cat.imageUrl}
                alt={cat.name}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                <div className="flex items-center gap-2 mb-1.5">
                  <i className={`${cat.icon} text-white/90 text-lg`}></i>
                  <h3 className="text-base md:text-lg font-heading font-semibold text-white">
                    {cat.name}
                  </h3>
                </div>
                <p className="text-xs text-white/70 line-clamp-2">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function FeaturedArticles() {
  const featured = articles.slice(0, 4);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950 mb-2">
              精选文章
            </h2>
            <p className="text-sm text-foreground-600">专业的美丽养护知识，为你精心准备</p>
          </div>
          <Link
            to="/category/skin-care"
            className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {featured.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-lg overflow-hidden cursor-pointer"
            >
              <div className="relative h-40 md:h-44 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs text-primary-500 bg-primary-50 px-2 py-0.5 rounded-full whitespace-nowrap">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                </div>
                <h3 className="text-sm md:text-base font-heading font-medium text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2">{article.excerpt}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function FeatureSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950 mb-3">
            为什么选择掌中美母
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            我们用心为每一位妈妈打造专属的美丽养护体验
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feature, idx) => (
            <div key={idx} className="text-center p-5 md:p-6 rounded-lg bg-background-100">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-50">
                <i className={`${feature.icon} text-xl text-primary-500`}></i>
              </div>
              <h3 className="text-base font-heading font-semibold text-foreground-950 mb-2">
                {feature.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function FAQSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-600">关于掌中美母，你可能会想知道</p>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <details key={idx} className="group bg-background-50 rounded-lg">
              <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer list-none">
                <h4 className="text-sm md:text-base font-medium text-foreground-950 pr-4">
                  {faq.question}
                </h4>
                <span className="flex-shrink-0 w-5 h-5 flex items-center justify-center text-foreground-400 group-open:hidden">
                  <i className="ri-add-line"></i>
                </span>
                <span className="flex-shrink-0 w-5 h-5 items-center justify-center text-foreground-400 hidden group-open:flex">
                  <i className="ri-subtract-line"></i>
                </span>
              </summary>
              <div className="px-4 md:px-5 pb-4 md:pb-5">
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}

function CTASection() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Soft%20warm%20abstract%20gradient%20with%20cream%20and%20blush%20pink%20tones%2C%20elegant%20flowing%20shapes%2C%20gentle%20feminine%20atmosphere%2C%20minimalist%20artistic%20design%2C%20dreamy%20and%20inspiring%20background%2C%20subtle%20texture&width=1800&height=800&seq=cta-bg-2026&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-black/30"></div>
      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-semibold text-white mb-4">
          准备好开启你的美丽蜕变了吗？
        </h2>
        <p className="text-sm md:text-base text-white/80 mb-8 max-w-lg mx-auto">
          关注掌中美母，获取专业的美丽养护方案和温暖的支持。每一位妈妈都值得被温柔以待。
        </p>
        <Link
          to="/about"
          className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-8 py-3.5 rounded-md font-medium text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
        >
          了解更多关于我们
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}

function FAQSchema() {
  const faqLD = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(faqLD) }}
    />
  );
}

export default function HomePage() {
  return (
    <>
      <SEOHead
        canonicalPath="/"
      />
      <FAQSchema />
      <HomeHero />
      <CategorySection />
      <FeaturedArticles />
      <FeatureSection />
      <FAQSection />
      <CTASection />
    </>
  );
}